import { Logger } from '@ori/logger';
import { APP_NAME, TEAM_NAME } from './constants';
export const mainLogger = new Logger(APP_NAME);
export const shoppingBasketMainLogger = new Logger(APP_NAME, {
    part: 'shopping-basket',
    teamName: TEAM_NAME
});
export const subscriptionsDeliveryMainLogger = new Logger(APP_NAME, {
    part: 'subscriptions-delivery-test',
    teamName: TEAM_NAME
});
